import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
        main: '#01458c', // Blue
    },
    secondary: {
      main: '#ff4081', // Pink
    },
  },
  typography: {
    fontFamily: 'Roboto, Arial, sans-serif',
    h1: {
      fontSize: '2.5rem',
    },
    body1: {
      fontSize: '1rem',
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: '8px',
        },
      },
    },
  },
});

export const lightTheme = createTheme({
  palette: {
    backgroundColor:'#ffffff',
    tableRowHoverBackgroundColor:'#f2f3f5',
    tableRowSelectedBackgroundColor:'#e1e1e3',
    color:'#242424',
    headerBackgroundColor: '#f5f5f5',
    dialogBackgroundColor: '#ffffff',
    textFieldBorderColor:'#bfbfbf',
    primary: {
      main: '#01458c', // Blue
    },
    secondary: {
      main: '#ff4081', // Pink
    },
  },
  typography: {
    fontFamily: 'Roboto, Arial, sans-serif',
    h1: {
      fontSize: '2.5rem',
    },
    body1: {
      fontSize: '1rem',
    },
  },
  components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    borderRadius: '8px',
                },
            },
        },
        MuiTableCell: {
            styleOverrides: {
                head: {
                    fontWeight: 'bold',
                    color: '#000000',
                    backgroundColor: "#ffffff",
                },
            },
        },
        // MuiInputLabel: {
        //     styleOverrides: {
        //         root: {
        //             color: theme.palette.color, 
        //             "&.Mui-focused": {
        //               color: theme.palette.color, 
        //             },
        //         },
        //     },
        // },
        // MuiSelect: {
        //     styleOverrides: {
        //         outlined: {
        //             "& .MuiOutlinedInput-notchedOutline": {
        //               borderColor: "#000000",
        //             },
        //             "&:hover .MuiOutlinedInput-notchedOutline": {
        //               borderColor: "#1565c0",
        //             },
        //         },
        //     },
        // },
        // MuiChip: {
        //     styleOverrides: {
        //         root: {
        //             backgroundColor: "#e0e0e0",
        //         },
        //     },
        // },
    },
});

export const darkTheme = createTheme({
  palette: {
    backgroundColor:'#121212',
    tableRowHoverBackgroundColor:'#2a2a2a',
    tableRowSelectedBackgroundColor:'#3b3a3a',
    color:'#ffffff',
    contentCopy:'#9c9b9c',
    headerBackgroundColor: '#212121',
    dialogBackgroundColor: '#17181C',
    textFieldBorderColor: '#ffffff',
    gradientInnerColor: 'rgba(82, 0, 255, 0.55) 0%',
    gradientOuterColor: 'rgba(0, 0, 0, 0.55) 94%',
    accent: '#00DDFF',
    primary: {
      main: '#4A229F'
    },
    secondary: {
      main: '#9FA8FF'
    },
  },
  typography: {
    fontFamily: 'Roboto, Arial, sans-serif',
    h1: {
      fontSize: '2.5rem',
    },
    body1: {
      fontSize: '1rem',
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: '8px',
        },
      },
    },
    MuiTableCell: {
        styleOverrides: {
          head: {
            fontWeight: 'bold',
            color: '#ffffff',
            backgroundColor: "#121212",
          },
        },
    },
    MuiInputLabel: {
        styleOverrides: {
          root: {
            color: '#ffffff', 
            "&.Mui-focused": {
                color: '#9c9b9c', 
            },
          },
        },
      },
  },
});


export const testTheme = createTheme({
  palette: {
    backgroundColor:'#121212',
    tableRowHoverBackgroundColor:'#2a2a2a',
    color:'#ffffff',
    contentCopy:'#9c9b9c',
    headerBackgroundColor: '#212121',
    dialogBackgroundColor: '#17181C',
    textFieldBorderColor: '#ffffff',
    gradientInnerColor: 'rgba(82, 0, 255, 0.55) 0%',
    gradientOuterColor: 'rgba(0, 0, 0, 0.55) 94%',
    accent: '#00DDFF',
    primary: {
      main: '#4A229F'
    },
    secondary: {
      main: '#9FA8FF'
    },
  },
  components: {
    MuiTypography: {
      fontFamily: 'Roboto, Arial, sans-serif',
      h1: {
        fontSize: '2.5rem',
      },
      body1: {
        fontSize: '1rem',
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: '8px',
        },
      },
    },
    MuiTableCell: {
        styleOverrides: {
          head: {
            fontWeight: 'bold',
            color: '#ffffff',
            backgroundColor: "#121212",
          },
        },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          color: '#ffffff', 
          "&.Mui-focused": {
              color: '#9c9b9c', 
          },
        },
      },
    },
  },
});

// inject any theme properties we want exposed to css 
export const injectThemeToCSS = (theme) => {
    const root = document.documentElement;
    root.style.setProperty('--primary-main', theme.palette.primary.main);
    root.style.setProperty('--secondary-main', theme.palette.secondary.main);
    root.style.setProperty('--background-color', theme.palette.backgroundColor);
    root.style.setProperty('--text-color', theme.palette.color);
    root.style.setProperty('--headerBackgroundColor', theme.palette.headerBackgroundColor);
    root.style.setProperty('--tableRowHoverBackgroundColor', theme.palette.tableRowHoverBackgroundColor);
    root.style.setProperty('--tableRowSelectedBackgroundColor', theme.palette.tableRowSelectedBackgroundColor);
    root.style.setProperty('--dialogBackgroundColor', theme.palette.dialogBackgroundColor);
    root.style.setProperty('--contentCopy', theme.palette.contentCopy);
    root.style.setProperty('--gradientInnerColor', theme.palette.gradientInnerColor);
    root.style.setProperty('--gradientOuterColor', theme.palette.gradientOuterColor);
    root.style.setProperty('--accentColor', theme.palette.accent);
};

export default theme;